/*!
 * Oxify Nova Configurator — Oxify
 * Namespace: oxn_* (separate from Forge's oxf_*, HE5000's he_*, OXYREVO's ox_*)
 *
 * Difference from Forge: the BASE VARIANT is chosen inside the configurator.
 * A model chooser (Duo / Duo Pro / Quad) + ATA + Exterior + Interior resolve a
 * real base variant ID + price from an embedded matrix (auto-built from the linked
 * Shopify products). The shared "Nova Addons" (flooring, seats, BIBS, extras) layer
 * on top as separate cart line items. Save adds everything to the cart at once.
 */
(function(){
  'use strict';

  var CONFIG = (function(){
    try {
      var el = document.querySelector('script[data-oxn-config]');
      if (el && el.textContent) return JSON.parse(el.textContent);
    } catch(e){}
    return {};
  })();

  var MODELS = CONFIG.models || [];           // [{ key,label,sub,productId,url,image,priceFrom,optionNames,variants:[{id,ata,color,interior,price,available}] }]
  var MODEL_BY_KEY = {};
  MODELS.forEach(function(m){ MODEL_BY_KEY[m.key] = m; });

  // Exterior color name → swatch hex (fallback neutral). Used for the generated dots.
  var COLOR_MAP = {
    'oxify original': '#b7c2cb', 'tuxedo': '#1b1c1f', 'pearl': '#efe9df',
    'onyx': '#23262b', 'desert sage': '#9caa8a', 'desert ivory': '#e6dbc2',
    'platinum': '#ccd1d5', 'aqua marine': '#78c2c2', 'aquamarine': '#78c2c2',
    'black': '#26262a', 'warm beige': '#c8a882', 'warm beige ': '#c8a882',
    'slate gray': '#5a6470', 'slate grey': '#5a6470', 'stone gray': '#7f7f7f', 'stone grey': '#7f7f7f'
  };
  function colorHex(name){ return COLOR_MAP[String(name || '').trim().toLowerCase()] || '#8d9096'; }

  // Merchant-defined finish options/photos: [{ axis:'exterior'|'interior', value, model:'all'|'model1'..., src, swatch }]
  // When any blocks exist for an axis, they REPLACE the option list read from the variant
  // matrix (so exterior/interior can be defined universally, independent of the product).
  // A block scoped to the current model wins over an 'all' block for the image/swatch.
  var FINISH_IMAGES = CONFIG.finishImages || [];

  // Flagship exterior that should always lead the swatch row regardless of the block
  // authoring order. Without this, adding a new model's exterior blocks (whose "Oxify
  // Original" tile the merchant naturally drops in last) shuffles it to the end. Set
  // to '' via the "Lead exterior color" section setting to disable pinning.
  var LEAD_EXTERIOR = String(CONFIG.leadExterior == null ? 'Oxify Original' : CONFIG.leadExterior).trim().toLowerCase();
  function pinLeadExterior(list){
    if (!LEAD_EXTERIOR || !list || !list.length) return list;
    var lead = [], rest = [];
    list.forEach(function(v){
      (String(v).trim().toLowerCase() === LEAD_EXTERIOR ? lead : rest).push(v);
    });
    return lead.length ? lead.concat(rest) : list;
  }

  function findFinishImage(axis, value){
    var v = String(value || '').trim().toLowerCase();
    var scoped = null, generic = null;
    FINISH_IMAGES.forEach(function(f){
      if (!f || f.axis !== axis || !f.src) return;
      if (String(f.value || '').trim().toLowerCase() !== v) return;
      if (f.model && f.model === pick.modelKey) scoped = f.src;
      else if (!f.model || f.model === 'all') generic = f.src;
    });
    return scoped || generic;
  }
  function findFinishSwatch(axis, value){
    var v = String(value || '').trim().toLowerCase();
    var scoped = null, generic = null;
    FINISH_IMAGES.forEach(function(f){
      if (!f || f.axis !== axis || !f.swatch) return;
      if (String(f.value || '').trim().toLowerCase() !== v) return;
      if (f.model && f.model === pick.modelKey) scoped = f.swatch;
      else if (!f.model || f.model === 'all') generic = f.swatch;
    });
    return scoped || generic;
  }
  // Generic block-attribute lookup for a finish value (model-scoped wins over 'all').
  function findFinishAttr(axis, value, attr){
    var v = String(value || '').trim().toLowerCase();
    var scoped = null, generic = null;
    FINISH_IMAGES.forEach(function(f){
      if (!f || f.axis !== axis) return;
      if (String(f.value || '').trim().toLowerCase() !== v) return;
      var val = f[attr];
      if (val == null || val === '') return;
      if (f.model && f.model === pick.modelKey) scoped = val;
      else if (!f.model || f.model === 'all') generic = val;
    });
    return scoped != null ? scoped : generic;
  }
  // Ordered, de-duped list of block-defined option values for an axis, applicable to
  // the current model ('all' or scoped to it). Empty => fall back to the variant matrix.
  function finishOptionsFor(axis){
    var out = [], seen = {};
    FINISH_IMAGES.forEach(function(f){
      if (!f || f.axis !== axis || f.value == null) return;
      if (f.model && f.model !== 'all' && f.model !== pick.modelKey) return;
      var v = String(f.value).trim();
      if (v === '' || seen[v.toLowerCase()]) return;
      seen[v.toLowerCase()] = 1; out.push(v);
    });
    return out;
  }

  var ROOT = null;
  var state = {
    base: null,        // { modelKey, modelLabel, sub, ata, exterior, interior, variantId, price, url, image }
    floor: null,
    seatType: null,
    seatColor: null,
    bibs: null,
    wg: null,
    addons: {},
    included: {},
    reading: null,
    pressure: null,    // block-driven Pressure/ATA option: { label, price, variantId } (single-variant base)
    exteriorNote: '',  // customer's typed desired colour when "Custom Color" exterior is selected
    seatCount: 1,      // chosen count for single-type models (Duo/Pro)
    seatGroups: []     // [{ typeKey, count, color, colorVariant, customNote }] — 1 group (Duo/Pro) or 2 (Quad)
  };

  // ---------- Utilities ----------
  function money(n){ return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 }); }
  function plus(n){ return '+$' + Number(n).toLocaleString('en-US'); }
  function num(v){ var n = parseFloat(v); return isNaN(n) ? 0 : n; }
  function $(sel){ return ROOT.querySelector(sel); }
  function $$(sel){ return ROOT.querySelectorAll(sel); }
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function uniq(arr){ var seen = {}, out = []; arr.forEach(function(v){ if (!seen[v]){ seen[v] = 1; out.push(v); } }); return out; }
  // Distinct, non-empty option values. Drops null/blank and Shopify's single-variant
  // placeholder "Default Title" so a product with no real options never renders a "null"
  // swatch (that means the wrong product is linked — use the full-matrix listing).
  function optVals(arr){
    return uniq(arr.filter(function(v){
      if (v == null) return false;
      var s = String(v).trim();
      return s !== '' && s.toLowerCase() !== 'default title';
    }));
  }
  function atShort(ata){
    var s = String(ata || '');
    if (/spliced/i.test(s)) return 'Adjustable 1.5–2.0 ATA - Spliced (Non-ASME)';
    if (/ata/i.test(s)) return 'Adjustable 1.5–2.0 ATA';
    return s;
  }

  // ---------- Base-variant selector ----------
  // Currently-picked option values (per selected model). Held here so re-renders
  // can preserve the customer's choices where the new model still offers them.
  var pick = { modelKey: null, variantModel: null, ata: null, exterior: null, interior: null };

  // The listing the customer entered from (Configure button) + which model it matched.
  // Save returns to this exact listing ONLY while that same model is still selected;
  // if they switch models, Save follows the selected model's own product instead.
  var ENTRY = { returnUrl: null, modelKey: null };

  function bindModels(){
    $$('[data-oxn-model]').forEach(function(tile){
      tile.addEventListener('click', function(){
        $$('[data-oxn-model]').forEach(function(t){ t.classList.remove('is-on'); });
        tile.classList.add('is-on');
        selectModel(tile.getAttribute('data-oxn-model'));
      });
    });
  }

  function selectModel(modelKey){
    var m = MODEL_BY_KEY[modelKey];
    if (!m) return;
    pick.modelKey = modelKey;
    // Preserve prior model/ata/exterior/interior only if still valid for this model
    var vmodels = optVals(m.variants.map(function(v){ return v.model; }));
    var atas = optVals(m.variants.map(function(v){ return v.ata; }));
    var colors = optVals(m.variants.map(function(v){ return v.color; }));
    var interiors = optVals(m.variants.map(function(v){ return v.interior; }));
    if (vmodels.length && vmodels.indexOf(pick.variantModel) === -1) pick.variantModel = vmodels[0]; // Halo vs Halo-S (from product page)
    // Block-defined options win when present (universal, product-independent).
    var extOpts = finishOptionsFor('exterior');
    var intOpts = finishOptionsFor('interior');
    if (extOpts.length) colors = extOpts;
    if (intOpts.length) interiors = intOpts;
    colors = pinLeadExterior(colors); // flagship (Oxify Original) always leads, whatever the block order
    if (atas.indexOf(pick.ata) === -1) pick.ata = atas[0];
    if (colors.indexOf(pick.exterior) === -1) pick.exterior = colors[0];
    if (interiors.indexOf(pick.interior) === -1) pick.interior = interiors[0];
    renderAtaGroup(m, atas);
    renderExteriorGroup(m, colors);
    renderModelDropdown(m, vmodels); // Model (Oxify Halo / Halo - S / Halo - Extended) = option1 values
    renderFinishDropdown(m, atas);   // Finish (Matte/Glossy) = the model's own option3 values
    renderInteriorGroup(m, interiors);
    renderSeatCount();
    renumberSteps();
    resolveBase();
  }

  // Renumber the visible step circles 1..N so hiding the Pressure/Exterior steps
  // (single-option models) never leaves a gap like "1 … 4".
  function renumberSteps(){
    var n = 0;
    $$('.oxn-card').forEach(function(card){
      var numEl = card.querySelector('.oxn-step-num');
      if (!numEl || card.hidden) return;
      n++; numEl.textContent = n;
    });
  }

  // Representative (minimum) price for a given ATA under the current exterior/interior,
  // used to show a "+$X" delta on the pricier ATA options.
  function ataRepPrice(m, ata){
    var match = m.variants.filter(function(v){ return v.ata === ata; });
    var exact = match.filter(function(v){ return v.color === pick.exterior && v.interior === pick.interior; });
    var pool = exact.length ? exact : match;
    return pool.reduce(function(min, v){ return Math.min(min, v.price); }, Infinity);
  }

  function renderAtaGroup(m, atas){
    var wrap = $('#oxn-ata-pills');
    var card = $('#oxn-ata-card');
    if (!wrap) return;
    // Block-defined Pressure ADD-ON applies ONLY to a genuine single-variant base (no real
    // ATA variants) while the step is shown. If the product carries its own ATA variants
    // (Standard / Spliced) OR the step is hidden because ATA is chosen on the product page,
    // the selected base variant ALREADY includes the Spliced price — adding the block add-on
    // on top would charge the Spliced upcharge twice.
    var pOpts = finishOptionsFor('pressure');
    if (pOpts.length && atas.length < 2 && CONFIG.showPressure !== false) {
      if (card) card.hidden = (pOpts.length < 2);
      renderPressurePills(pOpts);
      return;
    }
    // Otherwise read the pressure choices from the base product's own ATA variants — the
    // selected variant's price IS the base, so there is no separate pressure add-on line.
    state.pressure = null;
    if (card) card.hidden = (CONFIG.showPressure === false) || (atas.length < 2);
    var minPrice = atas.reduce(function(min, a){ return Math.min(min, ataRepPrice(m, a)); }, Infinity);
    wrap.innerHTML = atas.map(function(a){
      var delta = ataRepPrice(m, a) - minPrice;
      var on = a === pick.ata;
      return '<button type="button" class="oxn-pill' + (on ? ' is-on' : '') + '" data-oxn-ata="' + esc(a) + '">' +
               '<span>' + esc(atShort(a)) + '</span>' +
               (delta > 0 ? '<span class="oxn-ata-delta">' + plus(delta) + '</span>' : '<span class="oxn-ata-delta">Included</span>') +
             '</button>';
    }).join('');
    wrap.querySelectorAll('[data-oxn-ata]').forEach(function(btn){
      btn.addEventListener('click', function(){
        pick.ata = btn.getAttribute('data-oxn-ata');
        wrap.querySelectorAll('[data-oxn-ata]').forEach(function(b){ b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        resolveBase();
      });
    });
  }

  function setPressure(val){
    state.pressure = {
      label: val,
      price: num(findFinishAttr('pressure', val, 'price')),
      variantId: findFinishAttr('pressure', val, 'variantId') || null
    };
  }
  // Block-defined pressure pills (label + price delta). Selecting adds the option's
  // price + variant (an add-on line) without changing the single base variant.
  function renderPressurePills(values){
    var wrap = $('#oxn-ata-pills');
    if (!state.pressure || values.indexOf(state.pressure.label) === -1) setPressure(values[0]);
    wrap.innerHTML = values.map(function(val){
      var price = num(findFinishAttr('pressure', val, 'price'));
      var on = state.pressure && state.pressure.label === val;
      return '<button type="button" class="oxn-pill' + (on ? ' is-on' : '') + '" data-oxn-pressure="' + esc(val) + '">' +
               '<span>' + esc(val) + '</span>' +
               (price > 0 ? '<span class="oxn-ata-delta">' + plus(price) + '</span>' : '<span class="oxn-ata-delta">Included</span>') +
             '</button>';
    }).join('');
    wrap.querySelectorAll('[data-oxn-pressure]').forEach(function(btn){
      btn.addEventListener('click', function(){
        setPressure(btn.getAttribute('data-oxn-pressure'));
        wrap.querySelectorAll('[data-oxn-pressure]').forEach(function(b){ b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        renderSummary();
      });
    });
  }

  function renderSwatchGroup(containerSel, values, pickKey, catAttr, axis){
    var wrap = ROOT.querySelector(containerSel);
    if (!wrap) return;
    wrap.innerHTML = values.map(function(val){
      var on = val === pick[pickKey];
      var img = findFinishImage(axis, val);
      var dotStyle = img
        ? 'background-image:url(&quot;' + esc(img) + '&quot;);background-size:cover;background-position:center;'
        : 'background:' + (findFinishSwatch(axis, val) || colorHex(val));
      return '<label class="oxn-swatch' + (on ? ' is-on' : '') + '" data-' + catAttr + '="' + esc(val) + '">' +
               '<span class="oxn-swatch-dot" style="' + dotStyle + '"></span>' +
               '<span class="oxn-swatch-label">' + esc(val) + '</span>' +
               '<span class="oxn-swatch-check">✓</span>' +
             '</label>';
    }).join('');
    wrap.querySelectorAll('[data-' + catAttr + ']').forEach(function(el){
      el.addEventListener('click', function(){
        pick[pickKey] = el.getAttribute('data-' + catAttr);
        wrap.querySelectorAll('[data-' + catAttr + ']').forEach(function(s){ s.classList.remove('is-on'); });
        el.classList.add('is-on');
        resolveBase();
      });
    });
  }

  function renderExteriorGroup(m, colors){
    var card = $('#oxn-exterior-card');
    // Hide when the merchant moved exterior to the product-page variant dropdown
    // (showExterior=false), or when a model has no exterior option at all. The swatches
    // are still rendered (hidden) so the entry variant's colour can pre-select one.
    if (card) card.hidden = (CONFIG.showExterior === false) || (colors.length < 1);
    renderExteriorSwatches(colors);
  }
  // Like renderSwatchGroup, but inserts the swatches BEFORE #oxn-ext-extra (the note /
  // custom-color box) so that box keeps filling the empty cells on the last swatch row.
  function renderExteriorSwatches(colors){
    var wrap = $('#oxn-exterior-swatches');
    if (!wrap) return;
    var extra = document.getElementById('oxn-ext-extra');
    wrap.querySelectorAll('[data-oxn-ext]').forEach(function(el){ el.parentNode.removeChild(el); });
    var frag = document.createDocumentFragment();
    colors.forEach(function(val){
      var on = val === pick.exterior;
      var img = exteriorImage(val);   // finish-aware: Glossy photo when Glossy is selected
      var dotStyle = img
        ? 'background-image:url(&quot;' + esc(img) + '&quot;);background-size:cover;background-position:center;'
        : 'background:' + (findFinishSwatch('exterior', val) || colorHex(val));
      var label = document.createElement('label');
      label.className = 'oxn-swatch' + (on ? ' is-on' : '');
      label.setAttribute('data-oxn-ext', val);
      label.innerHTML = '<span class="oxn-swatch-dot" style="' + dotStyle + '"></span>' +
                        '<span class="oxn-swatch-label">' + esc(val) + '</span>' +
                        '<span class="oxn-swatch-check">✓</span>';
      label.addEventListener('click', function(){
        pick.exterior = val;
        wrap.querySelectorAll('[data-oxn-ext]').forEach(function(s){ s.classList.remove('is-on'); });
        label.classList.add('is-on');
        resolveBase();
      });
      frag.appendChild(label);
    });
    if (extra) wrap.insertBefore(frag, extra); else wrap.appendChild(frag);
    setExteriorExtraSpan(colors.length);
    _swatchFinish = pick.ata; // remember which finish these swatch photos reflect
  }
  // Fill the empty cells on the last swatch row (desktop 4-col grid); full width on mobile.
  function setExteriorExtraSpan(n){
    var extra = document.getElementById('oxn-ext-extra');
    if (!extra) return;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
    if (mobile) { extra.style.gridColumn = '1 / -1'; return; }
    var cols = 4, lastRow = n % cols, remaining = (lastRow === 0) ? cols : (cols - lastRow);
    extra.style.gridColumn = 'span ' + remaining;
  }
  function renderInteriorGroup(m, interiors){
    var card = $('#oxn-interior-card');
    if (card) card.hidden = interiors.length < 1; // no real interior options (wrong/degenerate product)
    renderSwatchGroup('#oxn-interior-swatches', interiors, 'interior', 'oxn-int', 'interior');
  }
  // Large hero preview of the selected interior leather (uses the block's own photo).
  function updateInteriorPreview(){
    var preview = ROOT && ROOT.querySelector('.oxn-step-preview[data-oxn-preview="Interior"]');
    if (!preview) return;
    var imgEl = preview.querySelector('[data-oxn-preview-img]');
    var emptyEl = preview.querySelector('.oxn-preview-empty');
    var captionEl = preview.querySelector('[data-oxn-preview-caption]');
    var src = findFinishImage('interior', pick.interior);
    var label = pick.interior || '';
    if (src) {
      if (imgEl) { imgEl.src = src; imgEl.alt = label; imgEl.hidden = false; }
      if (captionEl) { captionEl.textContent = label; captionEl.hidden = false; }
      if (emptyEl) emptyEl.hidden = true;
    } else {
      if (imgEl) { imgEl.hidden = true; imgEl.src = ''; }
      if (captionEl) captionEl.hidden = true;
      if (emptyEl) { emptyEl.textContent = label ? (label + ' (no preview image uploaded)') : 'Select an interior color to preview'; emptyEl.hidden = false; }
    }
  }
  // ---------- Finish (Matte / Glossy) — dropdown inside the Exterior step ----------
  // Options come from the base product's own option3 values and write pick.ata (the slot the base
  // variant resolves finish on). Selecting a finish re-resolves the right Matte/Glossy variant AND
  // swaps the exterior swatch + hero photos to that finish (see exteriorImage()). The finish chosen
  // on the product page pre-selects here (applyEntryContext clicks the hidden ATA pill; the dropdown
  // and the swatches then re-sync via resolveBase -> syncFinishDropdown + renderExteriorSwatches).
  function renderFinishDropdown(m, finishes){
    var row = $('#oxn-finish-row');
    var sel = $('#oxn-finish-select');
    if (row) row.hidden = finishes.length < 2; // nothing to choose if the product has one finish
    if (!sel) return;
    sel.innerHTML = finishes.map(function(f){
      return '<option value="' + esc(f) + '"' + (f === pick.ata ? ' selected' : '') + '>' + esc(f) + '</option>';
    }).join('');
    sel.onchange = function(){
      pick.ata = sel.value;
      resolveBase(); // resolveBase -> ensureSwatchFinish() re-skins the swatches to the new finish
    };
  }
  // Reflect pick.ata in the dropdown (it also changes via entry-sync from the product page).
  function syncFinishDropdown(){
    var sel = $('#oxn-finish-select');
    if (sel && sel.value !== pick.ata) sel.value = pick.ata;
  }
  // MODEL dropdown (option1: Oxify Halo / Halo - S / Halo - Extended). Mirrors the Finish
  // dropdown: populated from the model's own option1 values and hidden when there's only one.
  // Changing it re-resolves the base variant, so price/hero/summary follow the chosen model.
  function renderModelDropdown(m, vmodels){
    var row = $('#oxn-model-row');
    var sel = $('#oxn-model-select');
    if (row) row.hidden = vmodels.length < 2; // nothing to choose if the product has one model
    if (!sel) return;
    sel.innerHTML = vmodels.map(function(vm){
      return '<option value="' + esc(vm) + '"' + (vm === pick.variantModel ? ' selected' : '') + '>' + esc(vm) + '</option>';
    }).join('');
    sel.onchange = function(){
      pick.variantModel = sel.value;
      resolveBase(); // price, hero title/photo and summary all follow the selected model
    };
  }
  // Reflect pick.variantModel in the dropdown (also changes via entry-sync from the product page).
  function syncModelDropdown(){
    var sel = $('#oxn-model-select');
    if (sel && sel.value !== pick.variantModel) sel.value = pick.variantModel;
  }
  // Re-skin the exterior swatches to the current finish's photos whenever the finish changes
  // (covers BOTH the dropdown and the entry-sync-from-product-page path).
  var _swatchFinish = null;
  function ensureSwatchFinish(){
    if (_swatchFinish === pick.ata) return;
    var cols = currentColors();
    if (cols.length) renderExteriorSwatches(cols); // sets _swatchFinish
  }
  // The exterior options currently on screen, so a finish change can re-skin them in place.
  function currentColors(){
    var out = [];
    if (!ROOT) return out;
    ROOT.querySelectorAll('#oxn-exterior-swatches [data-oxn-ext]').forEach(function(el){
      out.push(el.getAttribute('data-oxn-ext'));
    });
    return out;
  }
  // Finish-aware exterior photo: the Glossy image when Glossy is picked (falls back to the default/
  // Matte image), else the default image. Lets each colour show a matte vs glossy photo.
  function exteriorImage(val){
    var glossy = /glossy/i.test(String(pick.ata || ''));
    if (glossy) {
      var g = findFinishAttr('exterior', val, 'srcGlossy');
      if (g) return g;
    }
    return findFinishImage('exterior', val);
  }

  // ---------- Custom exterior colour (text input + its own price delta) ----------
  // The exterior option whose label matches CONFIG.exteriorCustomLabel ("Custom Color")
  // reveals a free-text box for the customer's desired finish. Its +price comes from that
  // option block's own Price delta (e.g. +$4,000) + variant ID — no special-casing here.
  function isExteriorCustom(){
    var lbl = String(CONFIG.exteriorCustomLabel || 'Custom Color').trim().toLowerCase();
    var v = String(pick.exterior || '').trim().toLowerCase();
    // Match the exact custom label OR any value that starts with "custom" (e.g. the product
    // variant "Custom Color(call for details)"), so the custom UI is robust to label drift.
    return !!v && (v === lbl || isCustomColorValue(pick.exterior));
  }
  // A colour VALUE is "custom" when it starts with "custom" — this bridges label differences
  // like the swatch "Custom Color" vs the product variant "Custom Color(call for details)".
  function isCustomColorValue(s){ return !!s && String(s).trim().toLowerCase().indexOf('custom') === 0; }
  function syncExteriorCustomUI(){
    var custom = isExteriorCustom();
    // Swap the two in the same spot: lighting note when browsing, describe-color box on Custom.
    var note = document.getElementById('oxn-exterior-note');
    if (note) note.hidden = custom;
    var box = document.getElementById('oxn-ext-custom-note');
    if (box) {
      var wasHidden = box.hidden;
      box.hidden = !custom;
      if (custom && wasHidden) {
        var inp = document.getElementById('oxn-ext-custom-input');
        if (inp) setTimeout(function(){ try { inp.focus(); } catch(e){} }, 0);
      }
    }
    if (!custom) state.exteriorNote = '';
    var hint = document.getElementById('oxn-ext-custom-hint');
    if (hint) {
      // Surcharge for the message: the block's own price delta when present, otherwise the
      // configured custom surcharge (used when the +$ is baked into the base product variant,
      // so it's already in the total — we say so to avoid a double-charge worry).
      var p = (state.base && state.base.exteriorPrice > 0) ? state.base.exteriorPrice : (num(CONFIG.exteriorCustomSurcharge) || 0);
      var amt = '$' + Number(p).toLocaleString('en-US');
      hint.textContent = (p > 0 ? 'Custom color adds ' + amt + ' — already included in your estimated total. ' : '') +
        'Colors may vary with lighting and materials; our team confirms the exact finish with you before production.';
    }
  }
  function bindExteriorCustomInput(){
    var input = document.getElementById('oxn-ext-custom-input');
    if (!input) return;
    input.addEventListener('input', function(){
      state.exteriorNote = input.value;
      input.classList.remove('is-error');
      renderSummary();
    });
  }

  // Resolve the picked options to a concrete base variant + price.
  function resolveBase(){
    var m = MODEL_BY_KEY[pick.modelKey];
    if (!m) { state.base = null; updateHeroPrice(null); renderSummary(); return; }
    // Match on the dimensions the product ACTUALLY varies by. A null option on a variant
    // means the product has no such axis (e.g. a 2-ATA copy with block-defined colours has
    // color/interior = null) — treat null as "matches anything" so ATA still selects the
    // right variant (Standard vs Spliced) even though exterior/interior come from blocks.
    var wantCustom = isCustomColorValue(pick.exterior);
    var v = m.variants.find(function(x){
      var modelOk = (x.model == null || x.model === pick.variantModel);
      var ataOk = (x.ata == null || x.ata === pick.ata);
      var intOk = (x.interior == null || x.interior === pick.interior);
      // Custom swatch → the product's custom variant, even if labels differ
      // ("Custom Color" vs "Custom Color(call for details)").
      var colOk = (x.color == null) || (x.color === pick.exterior) || (wantCustom && isCustomColorValue(x.color));
      return modelOk && ataOk && colOk && intOk;
    });
    if (!v) {
      // Fall back to first available variant of this model so we never sit in a broken state
      v = m.variants[0];
    }
    // Show the variant's own Model (Oxify Halo vs Oxify Halo - S, synced from the product page)
    // as the label when the product carries that dimension; else the configured model label.
    var displayModel = (v && v.model) ? v.model : m.label;
    state.base = {
      modelKey: m.key,
      modelLabel: displayModel,
      model: v ? v.model : pick.variantModel,
      sub: m.sub || '',
      ata: pick.ata,
      exterior: pick.exterior,
      interior: pick.interior,
      variantId: v ? v.id : null,
      price: v ? v.price : 0,
      url: m.url || '',
      image: m.image || '',
      // Block-defined exterior/interior can add their own $0 (or priced) cart line item.
      exteriorVariant: findFinishAttr('exterior', pick.exterior, 'variantId'),
      exteriorPrice: num(findFinishAttr('exterior', pick.exterior, 'price')),
      interiorVariant: findFinishAttr('interior', pick.interior, 'variantId'),
      interiorPrice: num(findFinishAttr('interior', pick.interior, 'price')),
      // TRUE when the picked colour is already a real variant of the base product (its price is
      // in the base variant). Then the block's own price/variant are IGNORED so the colour is
      // never charged twice — e.g. a "Custom Color" variant at +$4,000 plus a $4,000 add-on block.
      exteriorInVariant: !!(v && v.color != null && (v.color === pick.exterior || (wantCustom && isCustomColorValue(v.color))))
    };
    updateHeroPrice(state.base);
    // "View Products" link follows the selected model, so switching model points the
    // customer at that model's own product listing.
    var vlink = ROOT.querySelector('.oxn-view-link');
    if (vlink && m.url) vlink.setAttribute('href', m.url);
    // Re-skin the exterior swatches if the finish just changed, then swap the hero to the
    // selected colour's photo in the current finish.
    ensureSwatchFinish();
    var extImg = exteriorImage(pick.exterior);
    swapHeroImage(extImg || m.image, m.label);
    syncExteriorCustomUI();
    syncFinishDropdown();
    syncModelDropdown();
    updateInteriorPreview();
    renderSummary();
  }

  function updateHeroPrice(base){
    var el = $('#oxn-hero-price');
    if (el) el.textContent = base ? money(base.price) : '—';
    var titleEl = $('#oxn-hero-title');
    if (titleEl && base) titleEl.textContent = base.modelLabel;
  }

  var _heroSwapped = false;
  function swapHeroImage(src, alt){
    if (!src) return;
    var heroImg = ROOT.querySelector('.oxn-hero-img img');
    var heroWrap = ROOT.querySelector('.oxn-hero-img');
    if (heroImg) { heroImg.src = src; heroImg.alt = alt || ''; }
    else if (heroWrap) { heroWrap.innerHTML = '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="lazy">'; }
    _heroSwapped = true;
  }

  // ---------- Add-on selection handlers (shared with Forge pattern) ----------
  function bindSwatches(){
    $$('[data-oxn-swatch]').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        var input = el.querySelector('input[type="radio"]');
        if (!input) return;
        var group = input.name;
        $$('input[name="' + group + '"]').forEach(function(inp){
          var lbl = inp.closest('[data-oxn-swatch]');
          if (lbl) lbl.classList.remove('is-on');
          inp.checked = false;
        });
        el.classList.add('is-on');
        input.checked = true;
        captureSwatch(el);
        renderSummary();
      });
    });
  }

  function captureSwatch(el){
    var cat = el.getAttribute('data-cat');
    var label = el.getAttribute('data-label');
    var price = num(el.getAttribute('data-price'));
    if (cat === 'Flooring') {
      state.floor = { label: label, price: price, variantId: el.getAttribute('data-variant') };
    }
    updateStepPreview(cat, el);
  }

  function updateStepPreview(cat, el){
    var preview = ROOT.querySelector('.oxn-step-preview[data-oxn-preview="' + cat + '"]');
    if (!preview) return;
    var imgEl = preview.querySelector('[data-oxn-preview-img]');
    var emptyEl = preview.querySelector('.oxn-preview-empty');
    var captionEl = preview.querySelector('[data-oxn-preview-caption]');
    var blockFallback = el ? el.getAttribute('data-fallback-image') : '';
    var sectionFallback = preview.getAttribute('data-hero-fallback') || '';
    var swatchSrc = el ? el.getAttribute('data-preview-image') : '';
    var label = el ? el.getAttribute('data-label') : '';
    var src = blockFallback || sectionFallback || swatchSrc;
    if (src) {
      if (imgEl) { imgEl.src = src; imgEl.alt = label || ''; imgEl.hidden = false; }
      if (captionEl) {
        if (label) { captionEl.textContent = label; captionEl.hidden = false; }
        else { captionEl.hidden = true; }
      }
      if (emptyEl) emptyEl.hidden = true;
      preview.classList.remove('is-empty');
    } else {
      if (imgEl) { imgEl.hidden = true; imgEl.src = ''; }
      if (captionEl) captionEl.hidden = true;
      if (emptyEl) { emptyEl.textContent = label ? label + ' (no preview image uploaded)' : 'Select an option to preview'; emptyEl.hidden = false; }
      preview.classList.add('is-empty');
    }
  }

  // ======================= SEATING (model-driven, quantity + shared colour) =======================
  // Seating is INCLUDED ($0). The seat count is a QUANTITY; all seats of a type share ONE colour.
  //   'count_type'  (Duo): count 1..max; 1 seat → Premium, 2+ → Electric Airline (count sets type)
  //   'airline_only'(Pro): count 1..max; Electric Airline; corner note shown once the count reaches it
  //   'quad'        (Quad): TWO quantities — Electric Airline (0..2) + Captain (0..2), max 2 each,
  //                         ≥1 total; each type carries its own single colour.
  // Each type's colour rides as a cart property + its $0 variant line (quantity = seat count).
  var SEATS = (CONFIG.seats || { types: [], colors: [], cornerNum: 3, cornerNote: '', customEnable: false, customLabel: 'Custom / Other', customHint: '' });

  function seatRule(modelKey){
    var m = MODEL_BY_KEY[modelKey] || {};
    var max = parseInt(m.maxSeats, 10); if (!(max > 0)) max = 2;
    return { max: max, mode: m.seatMode || 'count_type' };
  }
  function seatTypeLabel(key){
    var t = (SEATS.types || []).filter(function(x){ return x.key === key; })[0];
    if (t) return t.label;
    return key === 'electric' ? 'Electric Airline Seat' : key === 'first' ? 'Premium First Class Seat' : key === 'car' ? 'Car Seat' : key;
  }
  function colorsForType(typeKey){
    return (SEATS.colors || []).filter(function(c){
      var s = (c.appliesTo || 'all');
      if (s === 'all') return true;
      if (s === typeKey) return true;
      if (s === 'manual_electric' && (typeKey === 'electric' || typeKey === 'manual')) return true;
      return false;
    });
  }
  function colorVariantFor(color, typeKey){
    var v = (color && color.variants) || {};
    if (typeKey === 'electric') return v.electric || v.manual || v.regular || '';
    if (typeKey === 'first')    return v.first || v.regular || '';
    if (typeKey === 'car')      return v.car || v.regular || '';
    return v.regular || '';
  }
  function typeForSeatCount(mode, count){
    if (mode === 'airline_only') return 'electric';
    if (mode === 'count_type')   return count === 1 ? 'first' : 'electric';
    return 'electric';
  }
  function ensureGroupColor(g){
    var opts = colorsForType(g.typeKey);
    if (!opts.filter(function(c){ return c.label === g.color; })[0] && g.color !== SEATS.customLabel) {
      g.color = opts.length ? opts[0].label : null;
    }
    var col = opts.filter(function(c){ return c.label === g.color; })[0];
    g.colorVariant = col ? colorVariantFor(col, g.typeKey) : '';
    if (g.color !== SEATS.customLabel) g.customNote = '';
  }
  function groupByType(typeKey){
    var g = (state.seatGroups || []).filter(function(x){ return x.typeKey === typeKey; })[0];
    if (!g) g = { typeKey: typeKey, count: null, color: null, colorVariant: '', customNote: '' };
    return g;
  }
  // Entry point (called from selectModel)
  function renderSeatCount(){
    var rule = seatRule(pick.modelKey);
    var countWrap = $('#oxn-seat-count-wrap');
    if (rule.mode === 'quad') {
      if (countWrap) countWrap.hidden = true;
      rebuildQuad(rule);
    } else {
      if (countWrap) countWrap.hidden = false;
      rebuildSingle(rule);
    }
  }
  function rebuildSingle(rule){
    if (!state.seatCount || state.seatCount > rule.max) state.seatCount = Math.min(state.seatCount || 1, rule.max) || 1;
    if (state.seatCount < 1) state.seatCount = 1;
    var wrap = $('#oxn-seat-count');
    if (wrap) {
      var html = '';
      for (var i = 1; i <= rule.max; i++) html += '<button type="button" class="oxn-pill' + (i === state.seatCount ? ' is-on' : '') + '" data-oxn-seatcount="' + i + '"><span>' + i + '</span><span class="oxn-pill-sub">' + (i === 1 ? 'seat' : 'seats') + '</span></button>';
      wrap.innerHTML = html;
      wrap.querySelectorAll('[data-oxn-seatcount]').forEach(function(b){
        b.addEventListener('click', function(){ state.seatCount = parseInt(b.getAttribute('data-oxn-seatcount'), 10); rebuildSingle(rule); });
      });
    }
    var typeKey = typeForSeatCount(rule.mode, state.seatCount);
    var g = groupByType(typeKey);
    g.count = state.seatCount;
    ensureGroupColor(g);
    state.seatGroups = [g];
    var list = $('#oxn-seats-list');
    if (list) {
      list.innerHTML = '';
      list.appendChild(makeGroupCard(g, {
        title: seatTypeLabel(typeKey),
        qtyBadge: state.seatCount + (state.seatCount === 1 ? ' seat' : ' seats'),
        showCount: false,
        corner: (rule.mode === 'airline_only' && SEATS.cornerNum > 0 && state.seatCount >= parseInt(SEATS.cornerNum, 10))
      }));
    }
    renderSummary();
  }
  function rebuildQuad(rule){
    // Nova Quad is fixed: 2 Electric Airline + 2 Captain. No count picker — customer only chooses colours.
    var air = groupByType('electric');
    var cap = groupByType('car');
    air.count = 2;
    cap.count = 2;
    ensureGroupColor(air); ensureGroupColor(cap);
    state.seatGroups = [air, cap];
    var list = $('#oxn-seats-list'); if (!list) return;
    list.innerHTML = '';
    list.appendChild(makeGroupCard(air, { title: seatTypeLabel('electric'), showCount: false, qtyBadge: 'Number of Seats: 2' }));
    list.appendChild(makeGroupCard(cap, { title: seatTypeLabel('car'), showCount: false, qtyBadge: 'Number of Seats: 2' }));
    renderSummary();
  }
  function makeGroupCard(g, opts){
    var card = document.createElement('div');
    card.className = 'oxn-seat-card';
    var head = '<div class="oxn-seat-card-head"><span class="oxn-seat-num">' + esc(opts.title) + '</span>';
    if (!opts.showCount && opts.qtyBadge) head += '<span class="oxn-seat-type-fixed">' + esc(opts.qtyBadge) + '</span>';
    head += '</div>';
    card.innerHTML = head;
    if (opts.showCount) {
      var cp = document.createElement('div');
      cp.className = 'oxn-pills oxn-seat-count-pills';
      for (var n = 0; n <= (opts.maxCount || 2); n++) (function(n){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oxn-pill' + (g.count === n ? ' is-on' : '');
        b.innerHTML = '<span>' + n + '</span><span class="oxn-pill-sub">' + (n === 1 ? 'seat' : 'seats') + '</span>';
        b.addEventListener('click', function(){ setGroupCount(g.typeKey, n); });
        cp.appendChild(b);
      })(n);
      card.appendChild(cp);
    }
    if (opts.corner && SEATS.cornerNote) {
      var note = document.createElement('div');
      note.className = 'oxn-note oxn-seat-note';
      note.textContent = SEATS.cornerNote;
      card.appendChild(note);
    }
    if (g.count > 0) {
      // Big hero preview of the currently selected seat colour (mirrors the Flooring step).
      // Skipped entirely for Custom / Other — there's no photo, so no preview box is shown.
      if (g.color !== SEATS.customLabel) {
        var selCol = colorsForType(g.typeKey).filter(function(c){ return c.label === g.color; })[0];
        var heroSrc = (selCol && selCol.heroImage) ? selCol.heroImage : '';
        var pv = document.createElement('div');
        pv.className = 'oxn-step-preview oxn-seat-preview' + (heroSrc ? '' : ' is-empty');
        if (heroSrc) {
          // Blurred copy of the same photo fills the letterbox gaps; the sharp full image sits on top.
          pv.innerHTML = '<div class="oxn-seat-preview-bg" style="background-image:url(&quot;' + esc(heroSrc) + '&quot;)"></div>' +
                         '<img src="' + esc(heroSrc) + '" alt="' + esc(g.color || '') + '">' +
                         '<div class="oxn-preview-caption">' + esc(g.color || '') + '</div>';
        } else {
          pv.innerHTML = '<span class="oxn-preview-empty">' + (g.color ? esc(g.color) + ' (no preview image uploaded)' : 'Select a seat color to preview') + '</span>';
        }
        card.appendChild(pv);
      }
      var sw = document.createElement('div');
      sw.className = 'oxn-swatches oxn-seat-swatches';
      colorsForType(g.typeKey).forEach(function(c){
        var lab = document.createElement('label');
        lab.className = 'oxn-swatch' + (g.color === c.label ? ' is-on' : '');
        var dot = c.image ? 'background-image:url(&quot;' + esc(c.image) + '&quot;);background-size:cover;background-position:center;' : 'background:' + (c.swatch || '#cccccc');
        lab.innerHTML = '<span class="oxn-swatch-dot" style="' + dot + '"></span><span class="oxn-swatch-label">' + esc(c.label) + '</span><span class="oxn-swatch-check">✓</span>';
        lab.addEventListener('click', function(){ setGroupColor(g.typeKey, c.label); });
        sw.appendChild(lab);
      });
      if (SEATS.customEnable) {
        var cl = document.createElement('label');
        cl.className = 'oxn-swatch oxn-swatch--custom' + (g.color === SEATS.customLabel ? ' is-on' : '');
        cl.innerHTML = '<span class="oxn-swatch-dot oxn-swatch-dot--custom">＋</span><span class="oxn-swatch-label">' + esc(SEATS.customLabel) + '</span><span class="oxn-swatch-check">✓</span>';
        cl.addEventListener('click', function(){ setGroupColor(g.typeKey, SEATS.customLabel); });
        sw.appendChild(cl);
      }
      card.appendChild(sw);
      if (SEATS.customEnable) {
        var box = document.createElement('div');
        box.className = 'oxn-hero-custom-color oxn-seat-custom';
        box.hidden = g.color !== SEATS.customLabel;
        box.innerHTML = '<label class="oxn-hero-custom-label">Describe the ' + esc(opts.title) + ' colour</label>';
        var inp = document.createElement('input');
        inp.type = 'text'; inp.className = 'oxn-hero-custom-input'; inp.maxLength = 200; inp.placeholder = SEATS.customHint || '';
        inp.value = g.customNote || '';
        inp.setAttribute('data-oxn-seat-custom-type', g.typeKey);
        inp.addEventListener('input', function(){ g.customNote = inp.value; inp.classList.remove('is-error'); renderSummary(); });
        box.appendChild(inp);
        card.appendChild(box);
      }
    }
    return card;
  }
  function setGroupCount(typeKey, n){
    var g = groupByType(typeKey);
    g.count = n;
    ensureGroupColor(g);
    renderSeatCount();
  }
  function setGroupColor(typeKey, label){
    var g = groupByType(typeKey);
    g.color = label;
    ensureGroupColor(g);
    renderSeatCount();
    if (label === SEATS.customLabel) {
      setTimeout(function(){
        var el = ROOT.querySelector('.oxn-seat-custom input[data-oxn-seat-custom-type="' + typeKey + '"]');
        if (el) try { el.focus(); } catch(e){}
      }, 0);
    }
  }

  function bindBibs(){
    var sel = $('#oxn-bibs-select');
    if (!sel) return;
    sel.addEventListener('change', function(){ captureBibsSelect(sel); renderSummary(); });
  }
  function captureBibsSelect(sel){
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt || opt.value === 'none') { state.bibs = null; return; }
    state.bibs = {
      label: opt.getAttribute('data-label') || opt.text.trim(),
      price: num(opt.getAttribute('data-price')),
      variantId: opt.getAttribute('data-variant') || null
    };
  }

  function bindWhiteGlove(){
    var sel = $('#oxn-wg-select');
    if (!sel) return;
    sel.addEventListener('change', function(){ captureWgSelect(sel); renderSummary(); });
  }

  function captureWgSelect(sel){
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    state.wg = {
      tierKey: opt.value,
      label: opt.getAttribute('data-label'),
      price: num(opt.getAttribute('data-price')),
      variantId: opt.getAttribute('data-variant') || null
    };
  }

  function bindAddons(){
    $$('[data-oxn-addon]').forEach(function(row){
      var input = row.querySelector('input[type="checkbox"]');
      if (!input) return;
      row.addEventListener('click', function(e){
        if (e.target.tagName === 'INPUT') return;
        e.preventDefault();
        input.checked = !input.checked;
        toggleAddon(row, input);
      });
      input.addEventListener('change', function(){ toggleAddon(row, input); });
    });
  }
  function toggleAddon(row, input){
    row.classList.toggle('is-on', input.checked);
    var key = row.getAttribute('data-key');
    if (input.checked) {
      state.addons[key] = {
        label: row.getAttribute('data-label'),
        price: num(row.getAttribute('data-price')),
        variantId: row.getAttribute('data-variant')
      };
    } else {
      delete state.addons[key];
    }
    renderSummary();
  }

  function bindIncluded(){
    $$('[data-oxn-included]').forEach(function(row){
      var key = row.getAttribute('data-key');
      state.included[key] = { label: row.getAttribute('data-label'), variantId: row.getAttribute('data-variant') || null };
    });
    $$('[data-oxn-reading]').forEach(function(btn){
      btn.addEventListener('click', function(){
        $$('[data-oxn-reading]').forEach(function(b){ b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        state.reading = { chipLabel: btn.getAttribute('data-oxn-reading'), variantId: btn.getAttribute('data-variant') || null };
        renderSummary();
      });
    });
  }

  // ---------- Initialize state from default DOM selections ----------
  function initFromDom(){
    // Base: select the first model tile by default (or the one flagged is-on)
    var firstModel = $('[data-oxn-model].is-on') || $('[data-oxn-model]');
    if (firstModel) {
      $$('[data-oxn-model]').forEach(function(t){ t.classList.remove('is-on'); });
      firstModel.classList.add('is-on');
      selectModel(firstModel.getAttribute('data-oxn-model'));
    }
    var floor = $('[data-oxn-swatch][data-cat="Flooring"].is-on');
    if (floor) captureSwatch(floor);
    // Seats are rendered + initialised by renderSeatCount() (called from selectModel above).
    captureWgSelect($('#oxn-wg-select'));
    $$('[data-oxn-included]').forEach(function(row){
      state.included[row.getAttribute('data-key')] = { label: row.getAttribute('data-label'), variantId: row.getAttribute('data-variant') || null };
    });
    var chip = $('[data-oxn-reading].is-on');
    if (chip) state.reading = { chipLabel: chip.getAttribute('data-oxn-reading'), variantId: chip.getAttribute('data-variant') || null };
    captureBibsSelect($('#oxn-bibs-select'));
  }

  // ---------- Summary rendering ----------
  function renderSummary(){
    var box = $('#oxn-summary-rows');
    var totalEl = $('#oxn-total-value');
    if (!box || !totalEl) return;

    var rows = [];
    var total = 0;

    if (state.base) {
      var bSel = state.base.modelLabel;
      var extraBits = [];
      // Interior is shown on its OWN row below, so the base line carries only exterior (+ ATA if spliced).
      if (state.base.exterior) extraBits.push(state.base.exterior + (isExteriorCustom() && state.exteriorNote && state.exteriorNote.trim() ? ' (' + state.exteriorNote.trim() + ')' : ''));
      var ataBit = atShort(state.base.ata);
      if (/spliced/i.test(state.base.ata || '')) extraBits.unshift(ataBit);
      if (extraBits.length) bSel += ' — ' + extraBits.join(' · ');
      rows.push(row('Base Model', bSel, money(state.base.price)));
      total += state.base.price;
      // Exterior gets its own line only when it carries a price delta that isn't already in the
      // base variant (the $0 "included" exterior reads in the base row above).
      if (state.base.exteriorPrice > 0 && !state.base.exteriorInVariant) {
        var exSel = state.base.exterior;
        if (isExteriorCustom() && state.exteriorNote && state.exteriorNote.trim()) exSel += ': ' + state.exteriorNote.trim();
        rows.push(row('Exterior Color', exSel, plus(state.base.exteriorPrice))); total += state.base.exteriorPrice;
      }
      // Interior Leather — always its own row (Incl. when $0).
      if (state.base.interior) {
        rows.push(row('Interior Leather', state.base.interior, state.base.interiorPrice > 0 ? plus(state.base.interiorPrice) : 'Incl.'));
        total += state.base.interiorPrice || 0;
      }
      if (state.pressure) { rows.push(row('Pressure', state.pressure.label, state.pressure.price > 0 ? plus(state.pressure.price) : 'Incl.')); total += state.pressure.price || 0; }
    } else {
      rows.push(row('Base Model', 'Select a model to begin', '—'));
    }

    if (state.floor) rows.push(row('Flooring', state.floor.label, state.floor.price > 0 ? plus(state.floor.price) : 'Incl.'));

    (state.seatGroups || []).forEach(function(g){
      if (!g.count) return;
      var desc = (g.color || '');
      if (g.color === SEATS.customLabel && g.customNote && g.customNote.trim()) desc += ': ' + g.customNote.trim();
      rows.push(row(seatTypeLabel(g.typeKey) + ' × ' + g.count, desc, 'Incl.'));
    });

    if (state.bibs) {
      rows.push(row(CONFIG.bibsCat || 'BIBS System', state.bibs.label, state.bibs.price > 0 ? plus(state.bibs.price) : 'Incl.'));
      total += state.bibs.price;
    }

    if (state.wg && state.wg.label) {
      var wgPrice = state.wg.price || 0;
      rows.push(row('Delivery', state.wg.label, wgPrice > 0 ? plus(wgPrice) : 'Incl.'));
      total += wgPrice;
    }

    Object.keys(state.addons).forEach(function(k){
      var a = state.addons[k];
      rows.push(row('Add-on', a.label, plus(a.price)));
      total += a.price;
    });

    var includedNames = [];
    Object.keys(state.included).forEach(function(k){
      if (k === 'reading' && state.reading) includedNames.push(state.included[k].label + ' (' + state.reading.chipLabel + ')');
      else includedNames.push(state.included[k].label);
    });
    if (includedNames.length) rows.push(row('Included', includedNames.join(' · '), 'Incl.'));

    box.innerHTML = rows.join('');
    totalEl.textContent = money(total);
  }

  function row(cat, sel, price){
    // Category label on its own line; value + price share the line below (price aligned to the value).
    return '<div class="oxn-summary-row">' +
             '<div class="oxn-summary-cat">' + esc(cat) + '</div>' +
             '<div class="oxn-summary-line">' +
               '<div class="oxn-summary-sel">' + esc(sel) + '</div>' +
               '<div class="oxn-summary-price">' + esc(price) + '</div>' +
             '</div>' +
           '</div>';
  }

  // ---------- Validation ----------
  function validateAll(){
    var missing = [];
    $$('.oxn-card').forEach(function(c){ c.classList.remove('oxn-card-error'); });
    ROOT.querySelectorAll('.oxn-seat-custom input').forEach(function(el){ el.classList.remove('is-error'); });
    var extCustomInput = $('#oxn-ext-custom-input');
    if (extCustomInput) extCustomInput.classList.remove('is-error');

    function flagStep(stepNum, msg){
      var card = ROOT.querySelector('.oxn-card[data-step="' + stepNum + '"]');
      if (card) card.classList.add('oxn-card-error');
      missing.push(msg);
    }

    if (!state.base || !state.base.variantId) flagStep('base', 'Model: please choose a Nova model and its options.');
    if (isExteriorCustom() && !(state.exteriorNote && state.exteriorNote.trim())) {
      if (extCustomInput) extCustomInput.classList.add('is-error');
      flagStep('exterior', 'Exterior: please describe your desired custom color.');
    }
    if (!state.floor) flagStep('flooring', 'Flooring: please select a flooring option.');
    var totalSeats = (state.seatGroups || []).reduce(function(a, g){ return a + (g.count || 0); }, 0);
    if (totalSeats < 1) flagStep('seating', 'Seating: please select at least one seat.');
    (state.seatGroups || []).forEach(function(g){
      if (!g.count) return;
      var opts = colorsForType(g.typeKey);
      if (!g.color && opts.length) { flagStep('seating', 'Seating: please pick a colour for the ' + seatTypeLabel(g.typeKey) + '.'); return; }
      if (g.color === SEATS.customLabel && !(g.customNote && g.customNote.trim())) {
        var el = ROOT.querySelector('.oxn-seat-custom input[data-oxn-seat-custom-type="' + g.typeKey + '"]');
        if (el) el.classList.add('is-error');
        flagStep('seating', 'Seating: please describe the custom ' + seatTypeLabel(g.typeKey) + ' colour.');
      }
    });
    if (ROOT.querySelector('#oxn-wg-select') && !state.wg) flagStep('options', 'Delivery: please select a White Glove tier.');
    return missing;
  }

  // ---------- Total ----------
  function computeTotal(){
    var total = state.base ? (state.base.price || 0) : 0;
    if (state.base) total += (state.base.exteriorInVariant ? 0 : (state.base.exteriorPrice || 0)) + (state.base.interiorPrice || 0);
    if (state.pressure) total += state.pressure.price || 0;
    // Seating is included ($0) — no contribution to the total.
    if (state.bibs) total += state.bibs.price || 0;
    if (state.wg) total += state.wg.price || 0;
    if (state.floor) total += state.floor.price || 0;
    Object.keys(state.addons).forEach(function(k){ total += state.addons[k].price || 0; });
    return total;
  }

  // Build the add-on rows for the payload (everything except the base chamber).
  // Same shape as Forge's buildProductRows — the product-page snippet turns rows
  // with a variantId into cart line items and uses the rest for the summary/props.
  function buildRows(){
    var rows = [];
    // Block-defined exterior/interior with a variant ID → shared $0 (or priced) add-on line.
    // Skip exterior when it's chosen on the product-page variant (showExterior=false): the
    // colour is already part of the base variant, so an add-on line would duplicate it.
    if (state.base && state.base.exteriorVariant && CONFIG.showExterior !== false && !state.base.exteriorInVariant) {
      var extSel = state.base.exterior;
      var extNote = isExteriorCustom() ? (state.exteriorNote || '').trim() : '';
      if (extNote) extSel += ' (' + extNote + ')';
      rows.push({ cat: 'Exterior Color', sel: extSel, price: state.base.exteriorPrice || 0, variantId: state.base.exteriorVariant, exteriorNote: extNote });
    }
    if (state.base && state.base.interiorVariant) rows.push({ cat: 'Interior Leather', sel: state.base.interior, price: state.base.interiorPrice || 0, variantId: state.base.interiorVariant });
    // Block-defined pressure (e.g. Spliced +$3,000) → its own add-on line item.
    if (state.pressure && state.pressure.variantId) rows.push({ cat: 'Pressure', sel: state.pressure.label, price: state.pressure.price || 0, variantId: state.pressure.variantId });
    if (state.floor) rows.push({ cat: 'Flooring', sel: state.floor.label, price: state.floor.price || 0, variantId: state.floor.variantId });
    // Seat rows (included, $0). One row per type/group: its colour's $0 variant line at
    // quantity = seat count (for picking/inventory), plus a property on the main line.
    (state.seatGroups || []).forEach(function(g){
      if (!g.count) return;
      var isCust = g.color === SEATS.customLabel;
      var note = isCust ? (g.customNote || '').trim() : '';
      var sel = seatTypeLabel(g.typeKey) + ' × ' + g.count + (g.color ? ' – ' + g.color : '');
      if (note) sel += ' (' + note + ')';
      rows.push({ cat: 'Seating', sel: sel, price: 0, variantId: (g.colorVariant || null), qty: g.count, seatColorNote: note });
    });
    if (state.bibs) rows.push({ cat: CONFIG.bibsCat || 'BIBS System', sel: state.bibs.label, price: state.bibs.price, variantId: state.bibs.variantId });
    if (state.wg && state.wg.label) rows.push({ cat: 'White Glove Delivery', sel: state.wg.label, price: state.wg.price || 0, variantId: state.wg.variantId || null, wgTier: state.wg.tierKey });
    Object.keys(state.addons).forEach(function(k){ var a = state.addons[k]; rows.push({ cat: 'Add-on', sel: a.label, price: a.price, variantId: a.variantId, addonKey: k }); });
    Object.keys(state.included).forEach(function(k){
      var inc = state.included[k]; var vid = inc.variantId; var sel = inc.label;
      if (k === 'reading' && state.reading) { vid = state.reading.variantId; sel = inc.label + ' - ' + state.reading.chipLabel; }
      if (vid) rows.push({ cat: 'Included', sel: sel, price: 0, variantId: vid, includedKey: k });
    });
    return rows;
  }

  // ---------- Save & Return to Product (same cart flow as Forge) ----------
  // Redirect to the RESOLVED model's product page with the config payload + the
  // resolved base variant. The oxify-nova-product-config snippet on that page
  // renders the summary and intercepts the theme Add-to-Cart to add the bundle.
  function save(){
    var missing = validateAll();
    if (missing.length) {
      alert('Please complete the following before saving:\n\n• ' + missing.join('\n• '));
      var firstError = ROOT.querySelector('.oxn-card.oxn-card-error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var btn = $('#oxn-save-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }

    var b = state.base;
    // Unique id tying this configuration's base + add-ons together, so the cart can clean
    // up per-bundle (deleting one chamber's base removes only ITS add-ons).
    var bundleId = 'oxn-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    var payload = {
      total: computeTotal(),
      basePrice: b.price || 0,
      bundleId: bundleId,
      base: {
        variantId: b.variantId,
        modelLabel: b.modelLabel,
        model: b.model || '',
        pressure: state.pressure ? state.pressure.label : atShort(b.ata),
        pressureRaw: b.ata,
        exterior: b.exterior,
        exteriorNote: isExteriorCustom() ? (state.exteriorNote || '').trim() : '',
        interior: b.interior,
        price: b.price || 0
      },
      rows: buildRows()
    };
    // Where to Save: return to the exact ENTRY listing ONLY while the selected model is
    // still the one that listing represents. If the customer switched models, follow the
    // SELECTED model's own product instead — never send a Nova Duo build to a Duo Pro page.
    var ret;
    if (ENTRY.returnUrl && ENTRY.modelKey && ENTRY.modelKey === pick.modelKey) {
      ret = ENTRY.returnUrl;
    } else {
      ret = b.url || '/';
    }
    // Force ?variant= to the config's resolved variant, so the ATA/pressure the customer
    // ends on (inherited from the product page OR changed here) is what the product page
    // loads and adds to the cart. Strip any variant the return URL already carried.
    var qIdx = ret.indexOf('?');
    var path = qIdx > -1 ? ret.slice(0, qIdx) : ret;
    var qs = (qIdx > -1 ? ret.slice(qIdx + 1) : '').split('&').filter(function(kv){ return kv && kv.indexOf('variant=') !== 0; }).join('&');
    if (b.variantId) qs += (qs ? '&' : '') + 'variant=' + b.variantId;
    ret = path + (qs ? '?' + qs : '');
    var sep = ret.indexOf('?') > -1 ? '&' : '?';
    window.location.href = ret + sep + 'oxn_config=' + encodeURIComponent(JSON.stringify(payload));
  }

  // ---------- Init ----------
  function init(){
    ROOT = document.getElementById('oxn-config-' + CONFIG.sectionId);
    if (!ROOT) return;
    bindModels();
    bindSwatches();
    bindBibs();
    bindWhiteGlove();
    bindExteriorCustomInput();
    bindAddons();
    bindIncluded();
    initFromDom();
    renderSummary();
    applyEntryContext();
    var saveBtn = $('#oxn-save-btn');
    if (saveBtn) saveBtn.addEventListener('click', save);
    // Keep the in-grid note/custom cell spanning the right number of columns across breakpoints.
    window.addEventListener('resize', function(){
      if (!ROOT) return;
      var n = ROOT.querySelectorAll('#oxn-exterior-swatches [data-oxn-ext]').length;
      if (n) setExteriorExtraSpan(n);
    });
  }

  // When launched from a product page (Configure button passes ?return=<url>&title=<name>),
  // bind the visible context to THAT listing: the "View Products" link points to it, and
  // the hero/model name shows its exact title — so model, View link and cart all match the
  // listing the customer came from (the cart variant is re-resolved on the entry page).
  function applyEntryContext(){
    var p; try { p = new URLSearchParams(window.location.search); } catch(e){ return; }
    var title = p.get('title');
    var retParam = p.get('return');
    if (retParam && retParam.indexOf('/') === 0) ENTRY.returnUrl = retParam;

    // Pick the model that actually matches the entry listing so we never rename the
    // wrong tile. Match the model whose label appears in the entry title, longest first
    // ("Nova Duo Pro" beats "Nova Duo" for a Duo Pro listing). Only override the display
    // once we've selected the right model — otherwise leave the real model name intact.
    var matched = null;
    if (title) {
      var t = title.toLowerCase();
      var bestLen = 0;
      MODELS.forEach(function(m){
        var lbl = String(m.label || '').toLowerCase().trim();
        if (lbl && t.indexOf(lbl) !== -1 && lbl.length > bestLen) { matched = m; bestLen = lbl.length; }
      });
      if (matched) {
        ENTRY.modelKey = matched.key; // remember which model this listing is
        if (matched.key !== pick.modelKey) {
          var tile = ROOT.querySelector('[data-oxn-model="' + matched.key + '"]');
          if (tile) {
            $$('[data-oxn-model]').forEach(function(x){ x.classList.remove('is-on'); });
            tile.classList.add('is-on');
            selectModel(matched.key);
          }
        }
      }
    }

    // Sync the ATA/pressure to the variant the customer picked on the product page
    // (?variant=, passed by the Configure button). Pre-selects the matching Pressure pill
    // so the visible step reflects their choice AND the price updates (Standard $68,999 vs
    // Spliced $71,999) — works whether the step is shown or hidden.
    var vParam = p.get('variant');
    var vid = vParam ? parseInt(vParam, 10) : 0;
    var mm = MODEL_BY_KEY[pick.modelKey];
    var mv = (vid && mm) ? mm.variants.filter(function(x){ return x.id === vid; })[0] : null;
    // Sync the MODEL (Oxify Halo vs Oxify Halo - S) from the entry variant, so the configurator
    // price matches whatever the customer chose in the product page's Model dropdown.
    if (mv && mv.model != null) { pick.variantModel = mv.model; resolveBase(); }
    if (mv && mv.ata != null) {
      var picked = false;
      ROOT.querySelectorAll('#oxn-ata-pills [data-oxn-ata]').forEach(function(btn){
        if (btn.getAttribute('data-oxn-ata') === mv.ata) { btn.click(); picked = true; }
      });
      if (!picked) { pick.ata = mv.ata; resolveBase(); }
    }

    // Sync the exterior colour the customer picked on the product page (?variant=) — so it
    // flows into the configured price + cart even when the Exterior step is hidden.
    if (mv && mv.color != null) {
      var pickedC = false;
      ROOT.querySelectorAll('#oxn-exterior-swatches [data-oxn-ext]').forEach(function(el){
        if (el.getAttribute('data-oxn-ext') === mv.color) { el.click(); pickedC = true; }
      });
      if (!pickedC) { pick.exterior = mv.color; resolveBase(); }
    }

    // Robust fallback: the product page also passes the colour by NAME (&color=). This
    // pre-selects the matching exterior swatch even when the entry variant ID isn't in the
    // configurator's own matrix (configurator-copy listings) or the colours come from blocks
    // instead of this product's variants — so a colour picked on the product page always
    // reflects here. Matched case-insensitively against the swatch labels.
    var colParam = p.get('color');
    if (colParam) {
      var want = String(colParam).trim().toLowerCase();
      var pickedN = false;
      ROOT.querySelectorAll('#oxn-exterior-swatches [data-oxn-ext]').forEach(function(el){
        if (String(el.getAttribute('data-oxn-ext')).trim().toLowerCase() === want) { el.click(); pickedN = true; }
      });
      // Unknown colour name (not offered for this model) → keep the current selection.
    }

    // Custom-colour bridge: the entry variant's colour may be "Custom Color(call for details)"
    // while the swatch is labelled "Custom Color" — select the custom swatch either way.
    var incomingColor = (mv && mv.color) || colParam || '';
    if (isCustomColorValue(incomingColor)) {
      ROOT.querySelectorAll('#oxn-exterior-swatches [data-oxn-ext]').forEach(function(el){
        if (isCustomColorValue(el.getAttribute('data-oxn-ext'))) el.click();
      });
    }

    // (View Products link follows the selected model — handled in resolveBase — so it
    // always points at the model the customer is currently configuring, not the entry.)

    // Show the exact entry title only when we matched (and thus selected) that model,
    // so the name, price and options all belong to the same listing.
    if (title && matched) {
      var ht = document.getElementById('oxn-hero-title');
      if (ht) ht.textContent = title;
      var onTile = ROOT.querySelector('[data-oxn-model].is-on .oxn-model-name');
      if (onTile) onTile.textContent = title;
      if (state.base) { state.base.modelLabel = title; renderSummary(); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
